import { Button } from "antd";
import { MdArrowForwardIos } from "react-icons/md";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utility";

export type PaymentChipRow = { icon?: ReactNode; label: string; total: number; currency: string };

const PaymentChip: FC<{ rows: PaymentChipRow[]; title: string; onClick?: () => void }> = ({ rows, title, onClick }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2 rounded-md p-3 outline outline-border-minimal">
      <div className="flex items-center justify-between">
        <div className="text-font-subtle text-sm font-semibold">{title}</div>
        {onClick && (
          <Button
            type="link"
            icon={<MdArrowForwardIos className="w-4! h-4! rtl:-scale-x-100" />}
            iconPlacement="end"
            className="text-sm! flex! items-center! m-0! p-0! text-font-active!"
            classNames={{ content: "p-0!" }}
            onClick={onClick}
          >
            {t("Flights.details.summary.viewDetails")}
          </Button>
        )}
      </div>
      <div className="h-px w-full bg-border-minimal" />
      <div className="flex flex-col gap-2">
        {rows.map((row, i) => (
          <div key={i} className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 text-sm font-normal">
              {row.icon && <div className="text-icon-active">{row.icon}</div>}
              <div className="text-font-subtle">{row.label}</div>
            </div>
            <div className="text-font-default text-sm font-semibold">
              {formatNumber(row.total)} {row.currency}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentChip;
